export default __webpack_public_path__ + "static/media/claude.4d6f7cba.svg";